export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const SET_RETURN_URL = 'SET_RETURN_URL';